import { type LocaleCode, getI18nConfig, AVAILABLE_LOCALES } from '@repo/i18n';

// ⚠️ DEFAULT LANGUAGE CONFIGURATION
export const DEFAULT_LOCALE: LocaleCode = 'ja';

// Fallback language when a translation is missing
export const FALLBACK_LOCALE: LocaleCode = 'en';

export type Locale = LocaleCode;
export { AVAILABLE_LOCALES };

// Get locale from localStorage or use default
function getInitialLocale(): LocaleCode {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;

  const stored = localStorage.getItem('openroom-locale');
  if (stored && (stored === 'en' || stored === 'ja' || stored === 'zh')) {
    return stored as LocaleCode;
  }

  return DEFAULT_LOCALE;
}

export default getI18nConfig(getInitialLocale());
